export const enum CircleColor {
  GREEN = "green",
  RED = "red",
  ORANGE = "orange",
}
